import { Component, ErrorInfo, ReactNode } from "react";

import { reportErrorToNR } from "../../util/reportErrorToNR";
import { BigError } from "./BigError";

export class ErrorBoundary extends Component<{
  children: ReactNode;
  fallback?: ReactNode;
  reloadAction?: () => void;
}> {
  public state = { hasError: false, message: "" };

  constructor(props: { children: ReactNode; reloadAction?: () => void }) {
    super(props);
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { componentStack } = errorInfo;
    reportErrorToNR(error, { componentStack });
    this.setState({ message: error.message });
  }

  render(): ReactNode {
    const fallback = this.props.fallback || <BigError message={this.state.message} />;
    return this.state.hasError ? fallback : this.props.children;
  }
}
